import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsPotentialTrafoIP, MultiOptDetails_2DS, MultiOptDetails_3DS, OptionsConnectedValueDef, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-potential-transformer',
  templateUrl: './ds-potential-transformer.component.html',
  styleUrls: ['./ds-potential-transformer.component.css']
})
export class DsPotentialTransformerComponent implements OnInit, OnChanges {

  @Input() dsPotentialTrafoObj: DsPotentialTrafoIP;
  @Input() soLockObtained: boolean;
  @Input() accessLevel: Array<UserType>;
  @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();

  disableForm: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';
  readonlyAccess: boolean = false;
  Hvr: any = {};
  hasAccessEE: boolean = false;
  hasAccessME: boolean = false;
  hasAccessPM: boolean = false;
  lockFields: boolean = false; // After HOM lock

  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    this.disableForm = true;
    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
      // this.checkUserEnabled();
    }
    if (this._dataService.hasReadOnlyAccess) {
      this.readonlyAccess = true;
    }
    this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    if (!this.dsPotentialTrafoObj.parentSORef.isDatasheetSubOrderEnabled) {
      this.lockFields = false;
    }
    else {
      this.lockFields = true;
    }

  }

  addNewPotTrafoMountingBlock() {
    this.dsPotentialTrafoObj.addPotTrafoMountingTypeDS(new MultiOptDetails_3DS("", "", ""));
  }
  removePotTrafoMountingBlock(_crDS: MultiOptDetails_3DS) {
    if (_crDS) {
      this.dsPotentialTrafoObj.removePotTrafoMountingTypeDS(_crDS);
    }
  }

  cachedPotTrafoMountingTyp: any = {};
  filterPotTrafoMountingTyp() {
    let _id = this._dataService.getProductVariantId_DS(this.dsPotentialTrafoObj.parentDSRef.dsPanelIP.prodType);
    if (this.cachedPotTrafoMountingTyp[_id] != null) {
      return this.cachedPotTrafoMountingTyp[_id];
    }
    this.cachedPotTrafoMountingTyp[_id] = this._dataService.potTrafoMountingTyp.filter((_obj: OptionsConnectedValueDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    if (this.cachedPotTrafoMountingTyp[_id] != null) {
      return this.cachedPotTrafoMountingTyp[_id];
    }
    var _result = !this._dataService.isGeneralPotTrafoMountingTyp(_id);
    this.cachedPotTrafoMountingTyp[_id] = _result;
    return _result;
  }

  filterPotTrafoMountingDrawing(_mtTyp: MultiOptDetails_3DS) {
     let _resultTmp = this._dataService.potTrafoMountingTyp.filter(opt => opt.optionId == _mtTyp.type2);

     let _result = this._dataService.potTrafoMountingTyp.filter((_obj: OptionsConnectedValueDef) => {
      if(_resultTmp != null && _resultTmp.length > 0) {
        if(_obj.optionId == _resultTmp[0].optionId) {
          return _resultTmp[0].connectedValueList;
        }
      }
    });

    let _resultFinal: string[] = [];
    _result.forEach(element => {
      element.connectedValueList.forEach(val => {
        _resultFinal.push(val);
      });
    });
    return _resultFinal;
  }

 sectionNoteChangePM(_event: any) {
    this.dsPotentialTrafoObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsPotentialTrafoObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsPotentialTrafoObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection: boolean) {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data)));
    }
  }
  reloadData() {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
    }
  }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessEE) {
      _validList.push(
        // new ValidationItem("Class of Insulation", !!this.dsPotentialTrafoObj.potTrafoInsulationCl, " required to save Datasheet."),
        new ValidationItem("EE Note", !!this.dsPotentialTrafoObj.sectionNoteEE, " required to save Datasheet.")
      );
      // for (let i = 0; i < this.dsPotentialTrafoObj.potTrafoMountingType.length; i++) {
      //   let pt = this.dsPotentialTrafoObj.potTrafoMountingType[i];
      //   _validList.push(
      //     new ValidationItem("Mounting Type #" + (i + 1), !!pt.type1, " required to save Datasheet."),
      //     new ValidationItem("Mounting Type Details #" + (i + 1), !!pt.type2, " required to save Datasheet."),
      //     new ValidationItem("ABB Drawing No. #" + (i + 1), !!pt.type3, " required to save Datasheet.")
      //   );
      // }
    }

    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsPotentialTrafoObj.sectionNotePM, " required to save Datasheet."));
    }
    if (this.hasAccessME) {
      _validList.push(new ValidationItem("ME Note", !!this.dsPotentialTrafoObj.sectionNoteME, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      // if (!this.dsPotentialTrafoObj.potTrafoInsulationCl || !this.dsPotentialTrafoObj.sectionNoteEE) {
      if (!this.dsPotentialTrafoObj.sectionNoteEE) {
        return false;
      }
      // for (let pt of this.dsPotentialTrafoObj.potTrafoMountingType) {
      //   if (!pt.type1 || !pt.type2 || !pt.type3) return false;
      // }
    }
    if (this.hasAccessPM) {
      if (!this.dsPotentialTrafoObj.sectionNotePM) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsPotentialTrafoObj.sectionNoteME) return false;
    }
    return true;
  }

}

